/* AK-INTENT-START
   ---- What a search term means ------------------------------------------
   One copy of the matching rules for every surface: the header dropdown, the
   location picker, the search results page and the search analytics. Before
   this each surface carried its own copy and they drifted (a leading "The"
   was understood on the results page and nowhere else).

   Rows are venues in one shape, { h, t, v, c, la, ln, s }: the city feed rows
   already are, and the results page maps the venue index onto it. Nothing in
   here touches the page. */
window.AKSearchIntent = (function () {
  var CONN = { n: 1, and: 1, nd: 1, '&': 1 };

  // Words that say nothing about which mall or locality was meant on their own.
  var GENERIC = {};
  ('mall malls road rd sector sec west east north south city phase nagar new near nearby the area ' +
   'play kids kid indoor outdoor park zone main block colony market plaza complex tower avenue ' +
   'square extension ext layout stage cross centre center hub point lane marg chowk station metro ' +
   'in at of for and opp opposite behind floor level fun time times walk grand lake world game games ' +
   'party jump adventure activity activities best top with me place places').split(' ').forEach(function (w) { GENERIC[w] = 1; });

  var BRAND_MAX = 30;   // a bigger match set means a generic word, not a brand
  var MALL_MAX = 25;    // a bigger match set means a generic place word

  function words(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[’'`]/g, '').replace(/&/g, ' & ')
      .split(/[^a-z0-9&]+/).filter(Boolean);
  }

  function key(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  /* Brand names join words with N, And or &, and parents type any of the
     three, spaced or glued. One key per connector spelling, each with and
     without a leading "The", so "barnyard" meets The Barnyard. */
  function keys(s) {
    var ws = Array.isArray(s) ? s : words(s);
    var bases = [ws];
    if (ws[0] === 'the' && ws.length > 1) bases.push(ws.slice(1));
    var out = [];
    bases.forEach(function (b) {
      ['', 'n', 'and'].forEach(function (c) {
        var k = b.map(function (w) { return CONN[w] ? c : w; }).join('');
        if (k && out.indexOf(k) === -1) out.push(k);
      });
    });
    return out;
  }

  // The typed term, glued, with and without a leading "the".
  function termKeys(term) {
    var ws = words(term);
    var out = [key(term)];
    if (ws[0] === 'the' && ws.length > 1) out.push(key(ws.slice(1).join(' ')));
    return out.filter(function (k, i) { return k && out.indexOf(k) === i; });
  }

  // The term starts one of the vendor keys. One direction only, so a short
  // vendor ("Play") is never pulled in by a longer term ("playzi").
  function vendorStarts(vendor, term) {
    var ts = termKeys(term).filter(function (t) { return t.length >= 3; });
    if (!ts.length) return false;
    var ks = keys(vendor);
    return ts.some(function (t) { return ks.some(function (k) { return k.indexOf(t) === 0; }); });
  }

  // The term and one of the vendor keys are a prefix of one another.
  function brandHit(vendor, term) {
    var ts = termKeys(term).filter(function (t) { return t.length >= 3; });
    if (!ts.length) return false;
    var ks = keys(vendor);
    return ts.some(function (t) {
      return ks.some(function (k) { return k.indexOf(t) === 0 || t.indexOf(k) === 0; });
    });
  }

  function brandPart(t) { return String(t || '').split('|')[0]; }

  function locPart(t) {
    var parts = String(t || '').split('|');
    return parts.length > 1 ? parts[parts.length - 1] : '';
  }

  /* Words left over after the brand ("m3m atrium mall", "sector 133 noida")
     pick the outlet. A word most outlets share ("sector", "mall") says nothing
     about which one was meant, so it only counts when at most half the brand
     carries it. */
  function scoreRest(hits, rest) {
    var has = function (x, w) {
      return words(x.t + ' ' + (x.c || '')).some(function (y) { return y.indexOf(w) === 0; });
    };
    var telling = rest.filter(function (w) {
      var n = hits.filter(function (x) { return has(x, w); }).length;
      return n > 0 && n * 2 <= hits.length;
    });
    hits.forEach(function (x) {
      x.score = telling.filter(function (w) { return has(x, w); }).length;
    });
    return hits;
  }

  /* Venues of the brand the term names. The brand is the longest run of
     leading words that starts a vendor name or the brand words of a title
     (sub-brands such as Happy Hive by Celesta Fiesta). Under five letters only
     an exact brand counts: "play" is a word, not P.L.A.Y. Each hit is a copy of
     its row with i (row order) and score. */
  function brands(term, rows) {
    rows = rows || [];
    if (!rows.length) return [];
    var tw = words(term);
    if (tw[0] === 'the' && tw.length > 1) tw = tw.slice(1);
    var memo = rows._akKeys || (rows._akKeys = rows.map(function (r) {
      return keys(r.v).concat(keys(brandPart(r.t)));
    }));
    for (var k = tw.length; k >= 1; k--) {
      var tk = tw.slice(0, k).filter(function (w) { return w !== '&'; }).join('');
      if (tk.length < 4) break;
      var hits = [];
      rows.forEach(function (r, i) {
        var ok = memo[i].some(function (x) { return tk.length < 5 ? x === tk : x.indexOf(tk) === 0; });
        if (ok) hits.push(copy(r, i));
      });
      if (!hits.length) continue;
      if (hits.length > BRAND_MAX) return [];
      /* One ordinary word that only starts a brand ("party" against
         PartyDay) and stands as a word of its own in other venue titles
         ("Baccha Party") is that word, not the brand. */
      if (k === 1 && !hits.some(function (x) { return words(brandPart(x.t) + ' ' + (x.v || '')).indexOf(tw[0]) > -1; })) {
        var own = {};
        hits.forEach(function (x) { own[x.i] = 1; });
        var elsewhere = rows.some(function (r, i) { return !own[i] && words(r.t).indexOf(tw[0]) > -1; });
        if (elsewhere) return [];
      }
      return scoreRest(hits, tw.slice(k).filter(function (w) { return !CONN[w] && w.length > 1; }));
    }
    return [];
  }

  function copy(r, i) {
    return { h: r.h, t: r.t, v: r.v, c: r.c, la: r.la, ln: r.ln, s: r.s, row: r, i: i, score: 0 };
  }

  /* Optimal string alignment distance: insertions, deletions, substitutions
     and a swapped pair of neighbours each cost one. */
  function lev(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        var c = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[m][n];
  }

  // Distance from the typed key to the start of a brand key. Parents stop
  // typing part way, so the brand is cut to about the length typed.
  // Runs of one letter count once, so "smash" meets Smaaash.
  function squeeze(s) { return s.replace(/(.)\1+/g, '$1'); }

  /* Distance from the typed key to the start of a brand key, which is cut to
     the length typed or one more (parents stop part way). Never shorter than
     what was typed: "blaze" is not a slip for "Laze...". The squeezed pass
     only runs while the squeezed term is still five letters long. Returns
     the best { d, cut, sq }, preferring the longer cut on a tie. */
  function near(t, k) {
    var best = { d: 99, cut: '', sq: false };
    var passes = [[t, k, false]];
    var st = squeeze(t);
    if (st.length >= 5 && st !== t) passes.push([st, squeeze(k), true]);
    else if (st.length >= 5) passes.push([t, squeeze(k), true]);
    passes.forEach(function (p) {
      [p[0].length, p[0].length + 1].forEach(function (len) {
        var cut = p[1].slice(0, Math.min(len, p[1].length));
        if (!cut) return;
        var d = lev(p[0], cut);
        // Squeezing only forgives doubled letters, never a slip on top of them.
        if (p[2] && d > 0) return;
        if (d < best.d || (d === best.d && cut.length > best.cut.length && best.sq === p[2])) {
          best = { d: d, cut: cut, sq: p[2] };
        }
      });
    });
    return best;
  }

  // Every venue title and vendor, glued from each word onwards, so a phrase
  // typed as written is recognised wherever it starts.
  function tails(list) {
    var out = [];
    list.forEach(function (s) {
      var ws = words(s).filter(function (w) { return !CONN[w]; });
      for (var j = 0; j < ws.length; j++) out.push(ws.slice(j).join(''));
    });
    return out;
  }

  function vocab(rows) {
    if (rows._akVocab) return rows._akVocab;
    return (rows._akVocab = tails(rows.map(function (r) { return r.t + ' | ' + (r.v || ''); })));
  }

  function candidates(rows) {
    if (rows._akCands) return rows._akCands;
    var seen = {}, out = [];
    function add(name, kk) {
      kk.forEach(function (k) {
        if (k.length < 4 || seen[k]) return;
        seen[k] = 1;
        out.push({ n: name, k: k });
      });
    }
    rows.forEach(function (r) {
      var v = String(r.v || '').trim();
      if (v) add(v, keys(v));
      var b = brandPart(r.t).trim();
      if (b) add(b, keys(b));
    });
    return (rows._akCands = out);
  }

  var STOP = { the: 1, of: 1, by: 1, for: 1, at: 1, n: 1, and: 1, '&': 1 };

  // The words every matched name opens with, without a dangling "The".
  function commonName(names) {
    var split = names.map(function (n) { return String(n).trim().split(/\s+/); });
    var out = [];
    for (var i = 0; i < split[0].length; i++) {
      var w = split[0][i];
      if (!split.every(function (s) { return s[i] && s[i].toLowerCase() === w.toLowerCase(); })) break;
      out.push(w);
    }
    while (out.length > 1 && STOP[out[out.length - 1].toLowerCase()]) out.pop();
    return out.join(' ');
  }

  /* The one listed brand a misspelt term most likely meant, or null.
     Only for terms of five letters or more, one slip up to seven letters and
     two beyond. Never when the term exists as typed (extra: more titles to
     check that against, such as the ones Shopify returned), and never when
     two different brands are equally close. Returns { name, key, sq, rest }. */
  function correct(term, rows, extra) {
    rows = rows || [];
    if (!rows.length) return null;
    var tw = words(term).filter(function (w) { return !CONN[w]; });
    if (tw[0] === 'the' && tw.length > 1) tw = tw.slice(1);
    var known = vocab(rows).concat(tails(extra || []));
    for (var k = tw.length; k >= 1; k--) {
      var t = tw.slice(0, k).join('');
      if (t.length < 5) break;
      // Letters scattered across one-letter words are mashing, not a name.
      if (t.length / k < 3) continue;
      if (known.some(function (x) { return x.indexOf(t) === 0; })) return null;
      var lim = t.length >= 9 ? 2 : 1;
      var best = 99, hits = [];
      candidates(rows).forEach(function (c) {
        var m = near(t, c.k);
        if (m.d < best) { best = m.d; hits = [{ c: c, m: m }]; }
        else if (m.d === best) hits.push({ c: c, m: m });
      });
      if (best > lim) continue;
      var cut = hits[0].m.cut, sq = hits[0].m.sq;
      // A wrong first letter ("cosmic" for Kosmic) needs six letters of evidence.
      if (best > 0 && cut.charAt(0) !== t.charAt(0) && t.length < 6) continue;
      if (!hits.every(function (h) { return h.m.cut === cut && h.m.sq === sq; })) return null;
      // Different first words that squeeze alike (Kidzilla, Kidzzilla) are two brands.
      var name = commonName(hits.map(function (h) { return h.c.n; }));
      if (!name) return null;
      return { name: name, key: cut, sq: sq, rest: tw.slice(k) };
    }
    return null;
  }

  // Venues of a brand given by its key, as correct() returns it.
  function ofBrand(fix, rows) {
    var hits = [];
    (rows || []).forEach(function (r, i) {
      var ks = keys(r.v).concat(keys(brandPart(r.t)));
      if (ks.some(function (k) { return (fix.sq ? squeeze(k) : k).indexOf(fix.key) === 0; })) hits.push(copy(r, i));
    });
    if (hits.length > BRAND_MAX) return [];
    return scoreRest(hits, (fix.rest || []).filter(function (w) { return w.length > 1; }));
  }

  /* A word that says nothing on its own, or the start of one being typed
     ("sout" for south, "lay" for layout). */
  function generic(w) {
    if (GENERIC[w]) return true;
    if (w.length < 3) return false;
    for (var g in GENERIC) if (g.length > w.length && g.indexOf(w) === 0) return true;
    return false;
  }

  /* Venues in the mall or locality the term names, read off the last part
     of the title ("... | M3M Atrium Mall Sector 57 Gurgaon"). Each telling
     word must be a word there, the last one only its start since the parent
     may still be typing; generic words ("mall", "road") are skipped. Or the
     whole term glued must start a run of those words, which is how "r city"
     meets "R City Mall" (and not R Cube) and "sector 57" meets "Sector 57".
     A term made only
     of generic words needs two of them ("metro walk") and the glued form.
     More than MALL_MAX matches means the term is too generic to mean a place. */
  function mall(term, rows) {
    var tw = words(term).filter(function (w) { return !CONN[w]; });
    var t = tw.join('');
    if (t.length < 4) return [];
    var allGeneric = tw.every(function (w) { return generic(w) || /^\d+$/.test(w); });
    if (allGeneric && tw.length < 2) return [];
    var last = tw.length - 1;
    // At least one word of three letters or more that names something.
    var telling = tw.some(function (w) { return w.length >= 3 && !generic(w) && !/^\d+$/.test(w); });
    var hits = [];
    (rows || []).forEach(function (r, i) {
      var lw = words(locPart(r.t));
      if (!lw.length) return;
      var ok = telling && tw.every(function (w, j) {
        if (generic(w)) return true;
        return lw.some(function (x) { return j === last ? x.indexOf(w) === 0 : x === w; });
      });
      for (var j = 0; !ok && j < lw.length; j++) {
        if (lw.slice(j).join('').indexOf(t) === 0) ok = true;
      }
      if (ok) hits.push(copy(r, i));
    });
    return hits.length > MALL_MAX ? [] : hits;
  }

  /* The category a term names, from the published alias map: the whole term
     ("kidzania") or its opening words ("play area near me"). */
  function category(term, aliases) {
    var tw = words(term);
    var t = tw.join(' ');
    if (!t || !aliases) return null;
    // The opening words glued, so "time zone" meets "timezone".
    var glued = {};
    for (var n = 1; n <= tw.length; n++) glued[key(tw.slice(0, n).join(''))] = n;
    var best = null;
    Object.keys(aliases).forEach(function (a) {
      var an = words(a).join(' ');
      if (!an) return;
      var hit = t === an || t.indexOf(an + ' ') === 0 || glued[key(an)];
      if (hit && (!best || an.length > best.a.length)) best = { a: an, k: aliases[a] };
    });
    return best;
  }

  /* A term five letters or longer that is the start of an alias ("kidzani",
     "trampolin"): confident on the results page, where the term is final. */
  function categoryPrefix(term, aliases) {
    var t = words(term).join(' ');
    if (t.length < 5 || !aliases) return null;
    var best = null;
    Object.keys(aliases).forEach(function (a) {
      var an = words(a).join(' ');
      if (an.indexOf(t) === 0 && (!best || an.length < best.a.length)) best = { a: an, k: aliases[a] };
    });
    return best;
  }

  return {
    words: words, key: key, keys: keys, termKeys: termKeys,
    vendorStarts: vendorStarts, brandHit: brandHit,
    brands: brands, correct: correct, ofBrand: ofBrand, mall: mall, category: category,
    categoryPrefix: categoryPrefix,
    lev: lev, GENERIC: GENERIC
  };
})();
/* AK-INTENT-END */

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    // Leaving the page either way. Aborting here means the request the browser
    // is about to kill dies as an AbortError, which the fetch handler already
    // ignores, instead of surfacing as a fake "Load failed" network error.
    this.abortController.abort();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    // Warm the city feed while the parent is still typing, so chain outlets
    // can be placed before the first paint rather than popping in after it.
    this.akFeed();
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    try {
      const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
      const currentButtonText = searchForTextElement?.innerText;
      if (!currentButtonText || !previousTerm) return;
      // Escape regex metacharacters: parents type "(", "+", "[" and these
      // would otherwise throw a SyntaxError and abort onChange before the
      // fetch ever runs, leaving the dropdown permanently stale.
      const escaped = previousTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const occurrences = currentButtonText.match(new RegExp(escaped, 'g'));
      // No match at all means the button is showing a different term than we
      // expect (a stale render). Nothing safe to replace, so leave it alone.
      if (!occurrences || occurrences.length > 1) return;
      searchForTextElement.innerText = currentButtonText.replace(previousTerm, newTerm);
    } catch (error) {
      if (window.AKSearchEmit) {
        window.AKSearchEmit('ak_search_error', {
          ak_error_stage: 'update_search_for_term',
          ak_error_reason: String((error && error.name) || 'error').slice(0, 40)
        });
      }
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    // One request in flight at a time. Dawn only aborts on form reset, so every
    // debounced keystroke left its request running: on a slow mobile connection
    // six to eight piled up, competed for bandwidth, and could land out of
    // order, painting results for "pla" over "play area". Latest wins; the
    // aborted ones are already ignored by the catch below.
    this.abortController.abort();
    this.abortController = new AbortController();
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    // Collections are requested explicitly rather than left to the endpoint
    // default, because the destination row is built from them. limit_scope=each
    // gives every type its own 10: the default shares one limit of 10 across
    // all types, so asking for collections had quietly cut venues to about 5.
    fetch(PredictiveSearch.akUrl(searchTerm), {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20 || error?.name === 'AbortError') {
          // Code 20 means the call was aborted
          return;
        }
        if (window.AKSearchEmit) {
          window.AKSearchEmit('ak_search_error', {
            ak_error_stage: 'fetch',
            ak_error_reason: String((error && error.message) || 'network').slice(0, 40)
          });
        }
        this.close();
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  /* Shopify returns at most 10 products and orders them with no regard for
     where the visitor is, so a Pune parent searching a chain can get 10 rows
     without a single Pune outlet near the top. Float the visitor's own city
     up, keeping the relative order inside each group. Runs before paint, so
     there is no visible reshuffle. AKLocation is the authoritative source:
     cart.attributes.ak_city, the only city Liquid can see, lags a change by a
     round trip. */
  akOrderByCity() {
    var city = '';
    try {
      city = (window.AKLocation && AKLocation.scope && AKLocation.scope().city) || '';
    } catch (error) {
      return;
    }
    city = String(city).trim().toLowerCase();
    if (!city) return;

    var list = this.querySelector('#predictive-search-results-products-list');
    if (!list) return;
    var rows = Array.prototype.slice.call(list.querySelectorAll('li[data-ak-city]'));
    if (rows.length < 2) return;

    // Matches go after the brand row when there is one, otherwise to the top.
    var anchor = list.querySelector('.ak-brand-row');
    for (var i = 0; i < rows.length; i++) {
      var li = rows[i];
      if ((li.getAttribute('data-ak-city') || '').trim().toLowerCase() !== city) continue;
      if (anchor) list.insertBefore(li, anchor.nextSibling);
      else list.insertBefore(li, list.firstChild);
      anchor = li;
    }
  }

  /* A bare locality is 21% of what parents type, and today it returns an
     arbitrary product list. The registry knows these names but only cities
     have a page, so this row does not link: it hands the match to the picker,
     which pins the area and navigates to the parent city collection, exactly
     as choosing it from the picker would. Sits above both columns, because the
     suggestions column does not exist when nothing matched, and because
     position one is where the clicks are. */
  /* One destination row at the top, in order of how specific it is:
       1. a locality the parent typed        -> sets the pin, then navigates
       2. a category page for their own city -> "Bowling Alleys in Pune"
     Only ever one, and nothing when neither applies. A typed place is the
     stronger signal, and a query that resolves to a place would otherwise also
     match its city collection and offer the same journey twice.

     Deliberately no generic city fallback: offering "activities in Pune" to
     someone who typed "snow" answers a question they did not ask. When we have
     nothing specific, the search they are already running is the better path. */
  akTopRow() {
    if (this.akPlaceRow()) return;
    this.akCategoryRow();
  }

  akVisitorCity() {
    try {
      return String((window.AKLocation && AKLocation.scope && AKLocation.scope().city) || '')
        .trim()
        .toLowerCase();
    } catch (error) {
      return '';
    }
  }

  /* A collection Shopify already returned whose own city is the visitor's.
     No word list and no new payload: if nothing relevant came back, no row. */
  akCategoryRow() {
    var city = this.akVisitorCity();
    if (!city) return false;
    var node = this.querySelector('#ak-collection-candidates');
    if (!node) return false;

    var rows;
    try {
      rows = JSON.parse(node.textContent || '[]');
    } catch (error) {
      return false;
    }

    for (var i = 0; i < (rows || []).length; i++) {
      var r = rows[i];
      if (!r || !r.u) continue;
      if (String(r.c || '').trim().toLowerCase() !== city) continue;
      // n null means the count was not available, which is not a reason to skip.
      if (r.n != null && r.n < 1) continue;
      // Captured rather than closing over the loop variable, which var scopes
      // to the function.
      var url = r.u;
      return this.akInsertRow(r.t, 'category', function () {
        window.location.assign(url);
      }, r.n > 1 ? 'See all ' + r.n : '');
    }
    return false;
  }

  akPlaceRow() {
    // The picker lists its own place matches above these results.
    if (this.akNoPlaceRow) return false;
    var box = this.querySelector('#predictive-search-results');
    if (!box || !window.AKPlaceJump) return false;

    var match = null;
    try {
      match = window.AKPlaceJump.lookup(this.getQuery());
    } catch (error) {
      return false;
    }
    if (!match) return false;

    return this.akInsertRow('Set location to ' + match.label, 'place', function () {
      window.AKPlaceJump.go(match);
    });
  }

  /* Shared chrome for all three. role="option" so keyboard navigation and the
     analytics click handler pick it up with no special casing. */
  akInsertRow(label, kind, onClick, hint) {
    var box = this.querySelector('#predictive-search-results');
    if (!box) return false;

    var list = document.createElement('ul');
    list.className = 'predictive-search__results-list list-unstyled ak-place-list';
    list.setAttribute('role', 'group');

    var item = document.createElement('li');
    item.id = 'predictive-search-option-place';
    item.className = 'predictive-search__list-item ak-place-row';
    item.setAttribute('role', 'option');
    item.setAttribute('aria-selected', 'false');
    item.setAttribute('data-ak-row', kind);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'predictive-search__item link link--text';
    button.setAttribute('tabindex', '-1');
    button.innerHTML =
      '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
      '<p class="predictive-search__item-heading h5"></p></div>';
    // textContent, not innerHTML: these labels come from the registry and the
    // collection titles.
    button.querySelector('p').textContent = label;
    // Same second line as "See all locations" on the brand row.
    if (hint) {
      var sub = document.createElement('div');
      sub.className = 'ak-brand-row__hint caption-with-letter-spacing';
      sub.textContent = hint;
      button.firstChild.appendChild(sub);
    }
    button.addEventListener('click', onClick);

    item.appendChild(button);
    list.appendChild(item);
    box.insertBefore(list, box.firstChild);
    return true;
  }

  /* ---- Chain outlets in the visitor's city --------------------------------
     Shopify returns at most 10 venues with no regard for place, so a Pune
     parent typing "skyjumper" could get ten outlets and neither of the two in
     Pune. The nightly geo feed for their city already lists every venue there,
     so when the query is clearly one vendor, that vendor's outlets in the city
     go to the top of the list: all of them, nearest first. Nothing new is
     published for this beyond the vendor name on each feed row. */
  akKey(s) {
    return AKSearchIntent.key(s);
  }

  /* Connector spellings (N, And, &) and an optional leading "The": the rules
     live in AKSearchIntent at the top of this file, shared with the results
     page and the analytics. Keep in step with the vendor keys in
     sections/predictive-search.liquid. */
  akKeys(s) {
    return AKSearchIntent.keys(s);
  }

  // The typed term starts one of the vendor keys.
  akVendorStarts(vendor, term) {
    return AKSearchIntent.vendorStarts(vendor, term);
  }

  // The typed term and one of the vendor keys are a prefix of one another.
  akBrandHit(vendor, term) {
    return AKSearchIntent.brandHit(vendor, term);
  }

  /* One fetch per city per page view, shared by every search box. */
  akFeed() {
    var city = this.akVisitorCity();
    if (!city) return null;
    var store = PredictiveSearch.akFeeds || (PredictiveSearch.akFeeds = {});
    if (store[city]) return store[city];

    // Each entry is { u, la, ln, km }: the URL plus the pool centre and radius
    // the ranker needs. A bare string is the older shape, still accepted.
    var meta = null;
    try {
      var node = document.getElementById('ak-feed-urls');
      meta = (node && JSON.parse(node.textContent || '{}')[city]) || null;
    } catch (error) {
      meta = null;
    }
    var url = (meta && (typeof meta === 'string' ? meta : meta.u)) || '';
    if (!url) return null;

    var entry = (store[city] = {
      data: null,
      promise: null,
      la: meta.la,
      ln: meta.ln,
      km: meta.km
    });
    entry.promise = fetch(url)
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) { entry.data = data; return data; })
      .catch(function () { return null; });
    return entry;
  }

  akOrigin() {
    try {
      var p = window.AKLocation && AKLocation.position && AKLocation.position();
      var lat = p ? parseFloat(p.lat) : NaN, lng = p ? parseFloat(p.lng) : NaN;
      if (isFinite(lat) && isFinite(lng) && (lat !== 0 || lng !== 0)) return { lat: lat, lng: lng };
    } catch (error) {}
    return null;
  }

  akKm(o, row) {
    var lat = parseFloat(row.la), lng = parseFloat(row.ln);
    if (!isFinite(lat) || !isFinite(lng)) return Infinity;
    var rad = Math.PI / 180;
    var a = Math.pow(Math.sin(((lat - o.lat) * rad) / 2), 2) +
      Math.cos(o.lat * rad) * Math.cos(lat * rad) * Math.pow(Math.sin(((lng - o.lng) * rad) / 2), 2);
    return 12742 * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  /* Same markup as snippets/ak-predictive-product.liquid, so an inserted outlet
     is indistinguishable from one Shopify returned. */
  akOutletNode(row, prefix, n) {
    var li = document.createElement('li');
    li.id = 'predictive-search-option-product-ak' + n;
    li.className = 'predictive-search__list-item';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.setAttribute('data-ak-city', row.c || '');

    var a = document.createElement('a');
    a.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + row.h;
    a.className = 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text';
    a.setAttribute('tabindex', '-1');

    var tuple = row.imd;
    if (tuple && tuple[0]) {
      var src = tuple[0].indexOf('http') === 0 ? tuple[0] : (prefix || '') + tuple[0];
      var img = document.createElement('img');
      img.className = 'predictive-search__image';
      img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=150';
      img.alt = tuple[3] || '';
      img.width = 50;
      if (tuple[1] > 0 && tuple[2] > 0) img.height = Math.round((50 * tuple[2]) / tuple[1]);
      a.appendChild(img);
    }

    var content = document.createElement('div');
    content.className = 'predictive-search__item-content predictive-search__item-content--centered';
    var heading = document.createElement('p');
    heading.className = 'predictive-search__item-heading h5';
    heading.textContent = row.t || '';
    content.appendChild(heading);
    a.appendChild(content);
    li.appendChild(a);
    return li;
  }

  akVendorOutlets() {
    var box = this.querySelector('#predictive-search-results');
    var list = this.querySelector('#predictive-search-results-products-list');
    if (!box || !list || box.hasAttribute('data-ak-outlets')) return;

    // Confident it is a brand: the typed term and the top venue's vendor are a
    // prefix of one another once punctuation and spaces are dropped. The same
    // test the section uses for the "See all locations" row.
    var vendor = this.akKey(box.getAttribute('data-ak-top-vendor'));
    if (!vendor || !this.akBrandHit(box.getAttribute('data-ak-top-vendor'), this.getQuery())) return;

    var feed = this.akFeed();
    if (!feed) return;
    if (!feed.data) {
      // Not back yet. Come round again when it is, unless the parent has
      // typed on and this box has already been replaced.
      var self = this;
      feed.promise.then(function () {
        if (feed.data && self.querySelector('#predictive-search-results') === box) {
          self.akVendorOutlets();
          // The outlets just moved venue rows without their events.
          self.akAfter();
        }
      });
      return;
    }

    var city = this.akVisitorCity();
    var inCity = [], nearby = [];
    for (var i = 0; i < (feed.data.items || []).length; i++) {
      var row = feed.data.items[i];
      // The top vendor, or any vendor the typed term starts: one brand can be
      // several legal entities ("Tooney Tales", "Tooney Tales Atrium", ...).
      if (!row || !row.h || (this.akKey(row.v) !== vendor && !this.akVendorStarts(row.v, this.getQuery()))) continue;
      if (String(row.c || '').trim().toLowerCase() === city) inCity.push(row);
      else nearby.push(row);
    }
    // The feed is every venue within reach of the city, not only inside it.
    // Outlets elsewhere in that radius are used only when the city has none.
    var rows = inCity.length ? inCity : nearby;
    box.setAttribute('data-ak-outlets', rows.length);
    if (!rows.length) return;

    var origin = this.akOrigin();
    if (origin) {
      var self2 = this;
      rows.sort(function (x, y) {
        var dx = self2.akKm(origin, x), dy = self2.akKm(origin, y);
        return dx < dy ? -1 : dx > dy ? 1 : 0;
      });
    }

    // Rows Shopify already returned are moved rather than duplicated.
    var have = {};
    Array.prototype.forEach.call(list.querySelectorAll('li > a[href*="/products/"]'), function (a) {
      var handle = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
      if (handle) have[handle] = a.parentNode;
    });

    // Outlets go to the very top, nearest first. The brand row then drops to
    // just below the last outlet: once the local outlets are on screen it is
    // the fallback for parents who want every location (zero taps against 97
    // outlet taps in the week to 16 Oct while it sat above them). With no
    // outlets in reach it stays at the top, where it is the only route.
    var brand = list.querySelector('.ak-brand-row');
    var anchor = null;
    for (var j = 0; j < rows.length; j++) {
      var node = have[rows[j].h] || this.akOutletNode(rows[j], feed.data.img_prefix, j + 1);
      // Named for analytics whether it was inserted or only promoted.
      node.setAttribute('data-ak-row', 'outlet');
      list.insertBefore(node, anchor ? anchor.nextSibling : list.firstChild);
      anchor = node;
    }
    if (brand && anchor) list.insertBefore(brand, anchor.nextSibling);
  }

  /* ---- Live events beneath their parent venue ----------------------------
     An event matches far fewer searches than its venue: the title leads with
     the occasion rather than the brand, it carries no category words, and the
     outlet promotion above only knows Fun products. So an event takes the
     position of its parent instead. Wherever the parent venue sits, whether Shopify
     returned it or the feed inserted it, its live events follow directly
     beneath, at most AK_EVENTS_PER_VENUE of them. A row Shopify returned for
     the same event is replaced rather than duplicated. Runs after every other
     reorder so none of them can split the pair, and is safe to run twice.
     Events whose parent is not in the list stay where Shopify put them. */
  akAttachEvents() {
    var list = this.querySelector('#predictive-search-results-products-list');
    var node = this.querySelector('#ak-event-map');
    if (!list || !node) return;

    var rows;
    try {
      rows = JSON.parse(node.textContent || '[]');
    } catch (error) {
      return;
    }
    if (!rows || !rows.length) return;

    var byParent = {};
    for (var r = 0; r < rows.length; r++) {
      if (!rows[r] || !rows[r].p || !rows[r].h) continue;
      (byParent[rows[r].p] = byParent[rows[r].p] || []).push(rows[r]);
    }

    function handleOf(li) {
      var a = li.querySelector('a[href*="/products/"]');
      if (!a) return '';
      return (a.getAttribute('href') || '').split('?')[0].split('#')[0].split('/products/')[1] || '';
    }

    // Snapshot first, because rows move while we walk.
    var items = Array.prototype.slice.call(list.children);
    var byHandle = {};
    for (var k = 0; k < items.length; k++) {
      var hk = handleOf(items[k]);
      if (hk && !byHandle[hk]) byHandle[hk] = items[k];
    }

    var placed = {};
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      var venue = items[i];
      var evs = byParent[handleOf(venue)];
      if (!evs || !venue.parentNode) continue;
      var anchor = venue;
      var taken = 0;
      for (var j = 0; j < evs.length && taken < PredictiveSearch.AK_EVENTS_PER_VENUE; j++) {
        var ev = evs[j];
        if (placed[ev.h]) continue;
        var old = byHandle[ev.h];
        if (old && old.parentNode) old.parentNode.removeChild(old);
        var li = this.akEventNode(ev, ++n);
        list.insertBefore(li, anchor.nextSibling);
        anchor = li;
        placed[ev.h] = true;
        taken++;
      }
    }
  }

  /* Same chrome as a product row, inset under the venue, with the date where
     the venue row would carry nothing. */
  akEventNode(ev, n) {
    var li = document.createElement('li');
    li.id = 'predictive-search-option-event-' + n;
    li.className = 'predictive-search__list-item ak-event-row';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.setAttribute('data-ak-row', 'event');

    var a = document.createElement('a');
    a.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + ev.h;
    a.className = 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text';
    a.setAttribute('tabindex', '-1');

    var img = ev.i || [];
    if (img[0]) {
      var pic = document.createElement('img');
      pic.className = 'predictive-search__image';
      pic.src = img[0];
      pic.alt = img[3] || '';
      pic.width = 40;
      pic.height = 40;
      a.appendChild(pic);
    }

    var content = document.createElement('div');
    content.className = 'predictive-search__item-content predictive-search__item-content--centered';
    var heading = document.createElement('p');
    heading.className = 'predictive-search__item-heading h5';
    heading.textContent = ev.t || '';
    var meta = document.createElement('div');
    meta.className = 'ak-event-row__meta caption-with-letter-spacing';
    meta.textContent = ev.d ? 'Event \u00b7 ' + ev.d : 'Event';
    content.appendChild(heading);
    content.appendChild(meta);
    a.appendChild(content);
    li.appendChild(a);
    return li;
  }

  /* ---- Category venues from the city feed ---------------------------------
     A category is a local question: nobody in Goregaon searching "play area"
     wants Paschim Vihar. Shopify fills its 10 slots by title relevance alone,
     so a metro with many titles carrying the words crowds out the city of
     the visitor. When the term is confidently a category (and not a brand), the
     visitor city feed supplies the list instead, ranked by the same comparator
     as the category page the top row links to, and the Shopify rows go. When
     the feed has nothing for the category, the Shopify rows stay as they are. */
  akBrandIntent() {
    var box = this.querySelector('#predictive-search-results');
    return !!box && this.akBrandHit(box.getAttribute('data-ak-top-vendor'), this.getQuery());
  }

  akCatIntent() {
    var node = this.querySelector('#ak-cat-intent');
    if (!node) return null;
    var it;
    try {
      it = JSON.parse(node.textContent || 'null');
    } catch (error) {
      return null;
    }
    if (!it || !it.k) return null;
    if (it.m === 'prefix') {
      // Mid-word ("bowl", "pla") is not confident enough to swap the list, and
      // three letters ("the" against "the funbox") is too short to trust. The
      // typed term has to end on a word boundary of the alias: "play" for
      // "play area", "escape" for "escape room".
      var term = String(this.getQuery() || '').toLowerCase().trim();
      if (term.length < 4 || String(it.a || '').charAt(term.length) !== ' ') return null;
    }
    return it;
  }

  /* The venue list, built empty when Shopify returned no products at all, in
     the same markup the section prints. */
  akEnsureList(box) {
    var list = this.querySelector('#predictive-search-results-products-list');
    if (list) return list;
    var wrap = this.querySelector('#predictive-search-results-groups-wrapper');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'predictive-search-results-groups-wrapper';
      wrap.className =
        'predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions';
      var before =
        box.querySelector('.predictive-search__loading-state') ||
        box.querySelector('#predictive-search-option-search-keywords');
      box.insertBefore(wrap, before || null);
    }
    // Desktop CSS hides the second column while this modifier is on.
    wrap.classList.remove('predictive-search__results-groups-wrapper--no-products');
    var group = document.createElement('div');
    group.className = 'predictive-search__result-group';
    group.innerHTML =
      '<div><h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing"></h2>' +
      '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products"></ul></div>';
    group.querySelector('h2').textContent = box.getAttribute('data-ak-products-heading') || '';
    wrap.appendChild(group);
    return group.querySelector('ul');
  }

  akCategoryVenues() {
    var box = this.querySelector('#predictive-search-results');
    if (!box || box.hasAttribute('data-ak-catlist')) return;
    var intent = this.akCatIntent();
    // A brand that happens to carry a category word is still a chain lookup.
    if (!intent || this.akBrandIntent()) return;
    if (!window.AKGeo || !AKGeo.rankFeed) return;

    var feed = this.akFeed();
    if (!feed) return;
    if (!feed.data) {
      var self = this;
      feed.promise.then(function () {
        if (feed.data && self.querySelector('#predictive-search-results') === box) {
          self.akCategoryVenues();
          self.akAfter();
        }
      });
      return;
    }

    // Feed s: 1 is Not Interested, which stays in (ranked after normal venues
    // in its distance band, as on the page); 2 is Unresponsive or Temp Shut,
    // which a five-row list has no room for.
    var ranked = AKGeo.rankFeed(feed.data.items || [], {
      city: this.akVisitorCity(),
      lat: feed.la,
      lng: feed.ln,
      km: feed.km,
      cats: [intent.k]
    })
      .filter(function (x) { return x.row.s !== 2; })
      .slice(0, PredictiveSearch.AK_CATEGORY_VENUES);
    box.setAttribute('data-ak-catlist', ranked.length);
    if (!ranked.length) return;

    var list = this.akEnsureList(box);
    if (!list) return;

    // A venue Shopify already rendered is reused rather than rebuilt.
    var have = {};
    Array.prototype.forEach.call(list.querySelectorAll('li > a[href*="/products/"]'), function (a) {
      var handle = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
      if (handle) have[handle] = a.parentNode;
    });
    var keep = [];
    for (var j = 0; j < ranked.length; j++) {
      var node = have[ranked[j].h] || this.akOutletNode(ranked[j].row, feed.data.img_prefix, 'c' + (j + 1));
      node.setAttribute('data-ak-row', 'category_venue');
      keep.push(node);
    }
    // Everything else goes, including the Shopify rows from other cities and their
    // events; akAttachEvents then puts live events back under these venues.
    while (list.firstChild) list.removeChild(list.firstChild);
    keep.forEach(function (n) { list.appendChild(n); });
  }

  /* ---- Misspelt brands, malls and localities, and nothing at all --------
     What is left once the term is neither a brand Shopify recognised nor a
     category. From the visitor city feed, in this order:
       1. a brand typed glued or spaced its own way ("funblock", "playdate")
          that Shopify returned nothing for
       2. a misspelt brand ("toony", "smash", "cosmic"), with a muted
          "Showing results for" line so the parent sees what was understood
       3. a mall or locality in the titles ("r city", "atrium", "khar west")
       4. nothing at all: the top of the city page, under "Popular near you"
     Never says a venue is missing. The "Search for" button stays, so a wrong
     guess costs nothing. */
  akSmartVenues() {
    var box = this.querySelector('#predictive-search-results');
    if (!box || box.hasAttribute('data-ak-intent')) return;
    var I = window.AKSearchIntent;
    var term = this.getQuery();
    if (!I || I.key(term).length < 3) return;
    // A recognised brand, or a category even mid-word, is handled above.
    if (this.akBrandIntent() || this.querySelector('#ak-cat-intent')) return;

    var feed = this.akFeed();
    if (!feed) return;
    if (!feed.data) {
      var self = this;
      feed.promise.then(function () {
        if (feed.data && self.querySelector('#predictive-search-results') === box) {
          self.akSmartVenues();
          self.akAfter();
        }
      });
      return;
    }

    var items = (feed.data.items || []).filter(function (r) { return r && r.h; });
    var open = items.filter(function (r) { return r.s !== 2; });
    var products = parseInt(box.getAttribute('data-ak-products'), 10) || 0;
    var titles = Array.prototype.map.call(
      this.querySelectorAll('#predictive-search-results-products-list .predictive-search__item-heading'),
      function (p) { return p.textContent || ''; }
    );

    var pick = null, kind = '', intent = '', note = '', heading = '';
    if (!products) {
      var b = I.brands(term, items);
      if (b.length) { pick = b; kind = 'outlet'; intent = 'brand'; }
    }
    if (!pick) {
      var fix = I.correct(term, items, titles);
      var fixed = fix ? I.ofBrand(fix, items) : [];
      if (fixed.length) { pick = fixed; kind = 'corrected'; intent = 'typo'; note = fix.name; }
    }
    if (!pick) {
      var m = I.mall(term, open);
      if (m.length) { pick = m; kind = 'mall'; intent = 'mall'; }
    }
    if (pick) {
      pick = this.akNearestFirst(pick, feed, intent !== 'mall');
    } else if (!products && !this.querySelector('[data-ak-row="place"]') && window.AKGeo && AKGeo.rankFeed) {
      // Same order as the city page, so these are the venues it leads with.
      pick = AKGeo.rankFeed(items, {
        city: this.akVisitorCity(), lat: feed.la, lng: feed.ln, km: feed.km, cats: []
      })
        .filter(function (x) { return x.row.s !== 2; })
        .map(function (x) { return x.row; });
      kind = 'popular';
      intent = 'popular';
      heading = PredictiveSearch.AK_POPULAR_HEADING;
    }
    box.setAttribute('data-ak-intent', intent || 'none');
    if (!pick || !pick.length) return;

    this.akShowVenues(box, pick.slice(0, PredictiveSearch.AK_CATEGORY_VENUES), feed.data.img_prefix, kind, {
      heading: heading,
      note: note
    });
  }

  /* Best fit to any words typed after the brand first ("toony atrium"), then
     the visitor city when sameCity, then nearest to the visitor, or to the
     centre of their city when there is no pin. */
  akNearestFirst(hits, feed, sameCity) {
    var o = this.akOrigin() || (isFinite(parseFloat(feed.la)) ? { lat: parseFloat(feed.la), lng: parseFloat(feed.ln) } : null);
    var city = this.akVisitorCity();
    var self = this;
    return hits.slice().sort(function (a, b) {
      if ((a.score || 0) !== (b.score || 0)) return (b.score || 0) - (a.score || 0);
      if (sameCity) {
        var ca = String(a.c || '').trim().toLowerCase() === city ? 0 : 1;
        var cb = String(b.c || '').trim().toLowerCase() === city ? 0 : 1;
        if (ca !== cb) return ca - cb;
      }
      if (o) {
        var da = self.akKm(o, a), db = self.akKm(o, b);
        if (da !== db) return da - db;
      }
      return (a.i || 0) - (b.i || 0);
    }).map(function (x) { return x.row || x; });
  }

  /* Replace the venue list with these feed rows, reusing any row Shopify
     already rendered. Optional heading for the column and a muted note line
     above the list. */
  akShowVenues(box, rows, prefix, kind, opts) {
    var o = opts || {};
    var list = this.akEnsureList(box);
    if (!list) return;
    var have = {};
    Array.prototype.forEach.call(list.querySelectorAll('li > a[href*="/products/"]'), function (a) {
      var handle = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
      if (handle) have[handle] = a.parentNode;
    });
    var keep = [];
    for (var j = 0; j < rows.length; j++) {
      var node = have[rows[j].h] || this.akOutletNode(rows[j], prefix, kind.charAt(0) + (j + 1));
      node.setAttribute('data-ak-row', kind);
      keep.push(node);
    }
    while (list.firstChild) list.removeChild(list.firstChild);
    keep.forEach(function (n) { list.appendChild(n); });

    var group = list.parentNode;
    var h2 = group && group.querySelector('h2');
    if (h2 && o.heading) h2.textContent = o.heading;
    var old = group && group.querySelector('.ak-search-note');
    if (old) old.parentNode.removeChild(old);
    if (o.note && group) {
      var p = document.createElement('p');
      p.className = 'ak-search-note caption-with-letter-spacing';
      p.appendChild(document.createTextNode(PredictiveSearch.AK_SHOWING_FOR + ' '));
      var b = document.createElement('span');
      b.className = 'ak-search-note__term';
      b.textContent = o.note;
      p.appendChild(b);
      group.insertBefore(p, list);
    }
  }

  /* At most n venues, each keeping the events beneath it. The brand row is a
     route rather than a venue and does not count. Used by the picker. */
  akTrimTo(n) {
    var list = this.querySelector('#predictive-search-results-products-list');
    if (!list) return;
    var count = 0, drop = false;
    Array.prototype.slice.call(list.children).forEach(function (li) {
      if (li.classList.contains('ak-brand-row')) return;
      if (!li.classList.contains('ak-event-row')) {
        count++;
        drop = count > n;
      }
      if (drop) list.removeChild(li);
    });
  }

  /* Every step that runs on a fresh render, in order. Shared by the header
     dropdown and the picker, so the two surfaces cannot drift apart. */
  akDecorate() {
    this.akTopRow();
    this.akOrderByCity();
    this.akVendorOutlets();
    this.akCategoryVenues();
    this.akSmartVenues();
    this.akAfter();
  }

  /* What has to run again whenever rows move, including after a late feed. */
  akAfter() {
    this.akAttachEvents();
    if (this.akLimit) this.akTrimTo(this.akLimit);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.akDecorate();
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

// How many live events may follow one venue in the dropdown.
PredictiveSearch.AK_EVENTS_PER_VENUE = 2;

// How many feed venues a category, misspelt brand, mall or empty search shows.
PredictiveSearch.AK_CATEGORY_VENUES = 5;

// Wording for the two lines akSmartVenues adds.
PredictiveSearch.AK_SHOWING_FOR = 'Showing results for';
PredictiveSearch.AK_POPULAR_HEADING = 'Popular near you';

// One request shape for every surface.
PredictiveSearch.akUrl = function (term) {
  return (
    routes.predictive_search_url +
    '?q=' + encodeURIComponent(term) +
    '&resources[type]=product,collection,query&resources[limit_scope]=each' +
    '&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
    '&section_id=predictive-search'
  );
};

/* ---- Headless use, for the location picker -------------------------------
   The dropdown steps only ever call querySelector and getQuery on their host,
   so a plain object on this prototype can stand in for the element and run
   the identical pipeline into any container. */
PredictiveSearch.akHost = function (root, term) {
  var host = Object.create(PredictiveSearch.prototype);
  host.querySelector = function (s) { return root ? root.querySelector(s) : null; };
  host.querySelectorAll = function (s) { return root ? root.querySelectorAll(s) : []; };
  host.getQuery = function () { return term || ''; };
  return host;
};

// Start the visitor city feed early; one fetch per page view, shared.
PredictiveSearch.akWarm = function () {
  try {
    PredictiveSearch.akHost(null, '').akFeed();
  } catch (error) {}
};

PredictiveSearch.akCache = {};

/* Fetch, render and decorate into slot. Resolves to the number of venue rows
   shown, or -1 when a newer call for the same slot superseded this one. */
PredictiveSearch.akRender = function (slot, term, opts) {
  var o = opts || {};
  var key = String(term || '').trim().toLowerCase();
  if (slot.akAbort) slot.akAbort.abort();
  var ctrl = (slot.akAbort = new AbortController());

  var host = PredictiveSearch.akHost(slot, term);
  host.akNoPlaceRow = true;
  host.akLimit = o.limit || 0;
  host.akFeed();

  var cached = PredictiveSearch.akCache[key];
  var got = cached
    ? Promise.resolve(cached)
    : fetch(PredictiveSearch.akUrl(term), { signal: ctrl.signal })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var markup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
          PredictiveSearch.akCache[key] = markup;
          return markup;
        });

  return got
    .then(function (markup) {
      if (ctrl.signal.aborted) return -1;
      slot.innerHTML = markup;
      PredictiveSearch.akStrip(slot);
      host.akDecorate();
      return slot.querySelectorAll(
        '#predictive-search-results-products-list > li:not(.ak-event-row):not(.ak-brand-row)'
      ).length;
    })
    .catch(function (error) {
      if (ctrl.signal.aborted || error?.code === 20 || error?.name === 'AbortError') return -1;
      if (window.AKSearchEmit) {
        window.AKSearchEmit('ak_search_error', {
          ak_error_stage: 'picker_fetch',
          ak_error_reason: String((error && error.message) || 'network').slice(0, 40)
        });
      }
      return 0;
    });
};

/* The picker shows destinations only. Query completions, pages, the spinner
   (which outside a predictive-search element never hides) and the "Search
   for" button (which needs the header form) are removed, then any column
   left empty, so the venue column takes the full width on desktop. */
PredictiveSearch.akStrip = function (slot) {
  var q = slot.querySelector('#predictive-search-results-queries-list');
  if (q && q.parentNode) q.parentNode.remove();
  slot
    .querySelectorAll(
      '.predictive-search__pages-wrapper, .predictive-search__loading-state, #predictive-search-option-search-keywords'
    )
    .forEach(function (n) { n.remove(); });
  slot.querySelectorAll('.predictive-search__result-group').forEach(function (g) {
    if (!g.children.length) g.remove();
  });
  var wrap = slot.querySelector('#predictive-search-results-groups-wrapper');
  if (wrap && !wrap.children.length) wrap.remove();
};

customElements.define('predictive-search', PredictiveSearch);